import * as $ from 'jquery';
import 'bootstrap';
import { memberPortal } from "../member-portal";

export class memberMyActivity {
	private memberBase:any = new memberPortal();
	private stmForm:any   = $('#members-activities-statement-form--lcp');
	private filtered10Data:any;
		initTables(): any {
			// //alert("came...");
		$('#enrichMyActivity').DataTable({
			//"processing" : true,
			"ajax" : {
				"url" : '/bin/services/new/getActivityLCPdetails',
				dataSrc : ''
			},
			"columns" : [ {
				"data" : "type"
			},{
				"data" : "activity_date"
			}, {
				"data" : "partner"
			}, {
				"data" : "description"
			},{
				"data" : "benefits"
			},{
				"data" : "award_points"
			},{
				"data" : "tier_points"
			}]
			
        });
        $.fn.dataTableExt.sErrMode = "console";
        $.fn.dataTable.ext.errMode = 'none';
		
		}
		
		initSelectizeInputs(): any {
		//alert("1");
		let _self = this;
		let inputSelectArr:any = $.makeArray(_self.stmForm.find('select'));

		_self.memberBase.initSelectizeInputs(inputSelectArr);
	}
	statementTableFilter(): any {
		//alert("3");
		let _self = this;
		let statementSelect = _self.stmForm.find('#miles-activities-period-select--lcp')[0].selectize;
		let memberActivityDataTable = $('#enrichMyActivity');
		let statementTable = $.fn.dataTable.Api('#enrichMyActivity');

		// sort by reverse year on load table
		statementTable.order( [[ 0, 'desc' ]] ).draw();

		// filter statement table based on month value (first column)
		statementSelect.on('change', function(val:any){
			//alert("value"+val);
			//val="Awards expiry";
			if (val === 'ALL') {
				console.log('All');
				statementTable
				.column(1).search('').draw();
				statementTable
				.order([[ 1, 'desc' ]])
				//.page.len(10).draw();
			} else if(parseInt(val) >= 2021){
				statementTable.column(1).search(val).draw();
			}else {
				statementTable.column(1).search(val).draw();
			}

			if (memberActivityDataTable.find('.dataTables_empty').length) {
				$(".miles-export-action .btn").attr({'disabled': 'disabled'});
			} else {
				$(".miles-export-action .btn").removeAttr('disabled');
			}

		});
		$.fn.dataTableExt.sErrMode = "console";
        $.fn.dataTable.ext.errMode = 'none';
	}
	
	
	}

let scope:Element = document.querySelector('#enrichMyActivity');

if (scope) {
	try {
	let membermyactivity = new memberMyActivity();
	membermyactivity.initSelectizeInputs();
	membermyactivity.initTables();
	membermyactivity.statementTableFilter();		
	} catch(e) {console.error(e);}
}
